<template>
    <div v-if="backdrop">
      <div
        class="modal fade"
        :class="modal.open ? 'show' : ''"
        style="display: block"
        tabindex="-1"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="py-3">
                <h5 class="modal-title">Beberapa Data Tidak Dapat Diproses</h5>
                <p class="mb-0">
                  Format data tanggal harus DD-MM-YYYY atau D-M-YYYY, pastikan tanggal telah sesuai dengan format sebelum mengimport data order.
                </p>
              </div>
              <button type="button" class="close" @click="resetData()" v-html="ic('close')" />
            </div>
  
            <form @submit.prevent="submit">
              <div class="modal-body m-0 p-0">
                <table class="table table-responsive mb-0">
                  <thead class="sticky-header">
                    <tr>
                      <th v-for="header in displayedHeaders" :key="header">{{ header }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in groupedData" :key="index">
                      <td>{{ row.no }}</td>
                      <td v-for="header in requiredHeaders" :key="header">{{ row[header] || 'valid' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
    </div>
  </template>
  
  <script>
  import helper from "@/assets/js/helper.js";
  
  export default {
    name: "FailedImported",
    props: {
      config: {
        view: false,
      },
      invalidDates: Array,
      requiredHeaders: {
        type: Array,
        default: () => ["Tgl Faktur", "Doc Date", "SO Date", "Shipdate"],
      },
      resetData: Function,
    },
  
    mixins: [helper],
  
    data() {
      return {
        backdrop: false,
        modal: {
          open: false,
        },
      };
    },
  
    computed: {
      displayedHeaders() {
        return ["No", ...this.requiredHeaders];
      },
  
      groupedData() {
        let grouped = {};
        this.invalidDates.forEach(({ row, column, value }) => {
          if (!grouped[row]) grouped[row] = { no: row + 2 };
          grouped[row][column] = value;
        });
        return Object.values(grouped);
      },
    },
  
    watch: {
      "config.view": function (view) {
        if (view) {
          this.backdrop = true;
          setTimeout(() => {
            this.modal.open = view;
          }, 100);
        } else {
          this.modal.open = view;
  
          setTimeout(() => {
            this.backdrop = view;
          }, 100);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .sticky-header {
    position: sticky;
    top: 0;
    background: #f6f7f7;
    z-index: 1000;
  }
  </style>
  